const getWizard = (compagnyChoice) => ({
    prefixTemplate: ({ id, contractId }) => `/rip/${id}/contracts/${contractId}`,
    items: [
        { name: '', target: `managementActHub/${compagnyChoice}` },
    ],
});

export default getWizard;
